import { Component, OnInit, Input, AfterViewInit, ElementRef, ViewChild, ViewChildren, QueryList, ViewEncapsulation, Output, EventEmitter, ChangeDetectorRef, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { CloseOnContainerBlurDirective } from '@techmore/share';
import { FocusableMenu } from '../../entity/focusable-menu';
import { Subscription } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { isIOS } from 'src/app/util';

/** 通關無障礙 AA 檢測中 */
@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MenuComponent implements OnInit, AfterViewInit , OnDestroy {
  isBrowser: boolean;
  _menu: Array<FocusableMenu>;
  @Input() set menu(menu: Array<FocusableMenu>) {
    if (menu && menu.length > 0) {
      this._menu = menu;
    }
  }
  get menu() { return this._menu; }
  @Input() level = 0;
  @Input() limit: number;
  @ViewChild('dropDownMenuRef', {static: false}) dropDownMenuRef: ElementRef;
  get dropDownMenu() {
    if (this.level === 0 || !this.dropDownMenuRef) {
      return undefined;
    }
    return this.dropDownMenuRef.nativeElement;
  }
  @ViewChildren(CloseOnContainerBlurDirective) ccbs: QueryList<CloseOnContainerBlurDirective>;

  isOpen = false;
  isSame = '';

  @ViewChildren('muneList') muneList: QueryList<any>;
  mlSubscription: Subscription;
  @Output() munuListRendComplete = new EventEmitter<void>();

  @Output() viewInit = new EventEmitter<any>();
  isIOS: boolean;

  constructor(
    private cd: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit() {
    if (this.isBrowser) {
      this.isIOS = isIOS();
    }
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (this.ccbs) {
        if (this.ccbs.length > 0) {
          this.turnOnDropdownMenuCCBListener(this.ccbs);
        }
        this.ccbs.changes.subscribe(ccbs => {
          this.turnOnDropdownMenuCCBListener(this.ccbs);
        });
      }
      this.mlSubscription = this.muneList.changes.subscribe(t => {
        this.onRenderEnd();
      });
    }
    this.viewInit.emit(true);
  }

  ngOnDestroy() {
    if (this.mlSubscription) { this.mlSubscription.unsubscribe(); }
  }

  onRenderEnd() {
    this.munuListRendComplete.emit();
  }

  onSubMenuInit(subMenuCmp: MenuComponent, subMenuCCB: CloseOnContainerBlurDirective) {
    subMenuCCB.tmCloseOnContainerBlur = subMenuCmp.dropDownMenu;
  }

  turnOnDropdownMenuCCBListener(ccbs: QueryList<CloseOnContainerBlurDirective>) {
    ccbs.forEach((ccb, index) => {
      let targetMenuItem;
      const targetDom: HTMLElement = ccb.toggler.nativeElement;
      const tLevel = +$(ccb.toggler.nativeElement).data('level');
      const tLevelIndex = +$(targetDom).data('index');
      targetMenuItem = this.menu[tLevelIndex];

      if (tLevel === 0) {
        targetMenuItem.listenOnOpen = (cb: () => void) => {
          $(ccb.toggler.nativeElement.parentElement).on('shown.bs.dropdown', (e) => {
            e.stopPropagation();
            cb();
          });
        };
        targetMenuItem.listenOnClose = (cb: () => void) => {
          $(ccb.toggler.nativeElement.parentElement).on('hide.bs.dropdown', (e) => {
            e.stopPropagation();
            cb();
          });
        };
      } else {
        targetMenuItem.listenOnOpen = (cb: () => void) => {
          $(ccb.toggler.nativeElement.parentElement).on('shown.bs.dropdown.sub', (e) => {
            e.stopPropagation();
            cb();
          });
        };
        targetMenuItem.listenOnClose = (cb: () => void) => {
          $(ccb.toggler.nativeElement.parentElement).on('hidden.bs.dropdown.sub', (e) => {
            e.stopPropagation();
            cb();
          });
        };
      }
    }); // end forEach ccb

    this.cd.detectChanges();
  }

  closeDpMenu = (toggler?: HTMLElement, container?: HTMLElement) => {
    const tLevel = +$(toggler).data('level');
    if (tLevel === 0) {
      // this.globalComponentService.openSanckBar(`close ${toggler.innerText} lv${tLevel}`);
      $(toggler).dropdown('toggle');
    } else {
      // this.globalComponentService.openSanckBar(`close ${toggler.innerText} lv${tLevel}`);
      this.onToggleSubMenu(toggler, tLevel);
    }
  }

  mobileFun(event, level, subMenu) {
    if (level === 1 && window.innerWidth <= 1000) {
      event.preventDefault();
      event.stopPropagation();
      if (this.isOpen && event.currentTarget.text !== this.isSame) { // 清除全部(第三層)
        const allMenu = subMenu.elementRef.nativeElement.parentElement.parentElement;
        for (let i = 0; i < allMenu.children.length; i++) {
          if (allMenu.children[i].children[1] != null) {
            allMenu.children[i].children[1].children[0].style.display = 'none';
          }
          this.isOpen = false;
        }
      }
      this.isSame = event.currentTarget.text;
      if (this.isOpen) {
        subMenu.elementRef.nativeElement.previousElementSibling.children[0].style.display = 'none';
        this.isOpen = false;
        return this.isOpen;
      } else {
        subMenu.elementRef.nativeElement.previousElementSibling.children[0].style.display = 'block';
        this.isOpen = true;
        return this.isOpen;
      }
    }
  }

  /** 巢狀子選單的切換 */
  toggleSubMenu($event, level: number) {
    if (level > 0) {
      // this.globalComponentService.openSanckBar(`subtoggle ${$event.target.innerText} lv${level}`);
      this.onToggleSubMenu($event.target, level);
      $event.stopPropagation();
      $event.preventDefault();
    } else {
      // this.globalComponentService.openSanckBar(`subtoggle ${$event.target.innerText} lv0`);
    }
  }

  onToggleSubMenu(toggler: HTMLElement, level: number) {
    const siblings = $(toggler).parent('li').siblings('li.dropdown-item');
    $.each(siblings, (i, v) => {
      if ($(v).hasClass('open')) {
        $(v).trigger('hidden.bs.dropdown.sub');
        $(v).removeClass('open').children('a.dropdown-toggle').attr('aria-expanded', 'false');
      }
    });

    const li = $(toggler).parent('li');
    if (li.hasClass('open')) {
      li.removeClass('open').trigger('hidden.bs.dropdown.sub');
      $(toggler).attr('aria-expanded', 'false');
    } else {
      li.addClass('open').trigger('shown.bs.dropdown.sub');
      $(toggler).attr('aria-expanded', 'true');
    }

    // $(toggler).find('li.dropdown-submenu').trigger('hide.bs.dropdown').removeClass('open').children('a.dropdown-toggle').attr('aria-expanded', 'false');
  }
}
